import Amplify, { API, Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';

import createParams from '../lib/createApiParams';
import customFetch from '../lib/customFetch';

const apiName = 'backoffice';
Amplify.configure(awsconfig);

async function getToken() {
  const { accessToken } = await Auth.currentSession();
  return accessToken.jwtToken;
}

// invitaciones
const consultarSolicitudes = async (userToken, cantidad, desde, hasta) => {
  const path = '/verOfertas';
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    cantidad,
    desde,
    hasta,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.get(apiName, path, myInit));
  return res;
};

const validarOferta = async (userToken, registro) => {
  const path = '/validarOferta';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

/* servicio de habilidades */

const consultarHabilidades = async (userToken) => {
  const path = '/habilidades';
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.get(apiName, path, myInit));
  return res;
};

const crearHabilidades = async (userToken, registro) => {
  const path = '/habilidades';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.put(apiName, path, myInit));
  return res;
};
const editarHabilidades = async (userToken, registro) => {
  const path = '/habilidades';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};
const cambioEstadoHabilidad = async (userToken, registro) => {
  const path = '/cambiarEstadoHabilidad';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

// funciones para crear y editar usuario
const consultarTrabajador = async (
  userToken,
  empresaId,
  correo,
  cantidad,
  LastEvaluatedKey
) => {
  const path = '/trabajador';
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    empresaId,
    correo,
    cantidad,
    LastEvaluatedKey,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.get(apiName, path, myInit));
  return res;
};
const crearTrabajador = async (userToken, registro) => {
  const path = '/trabajador';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.put(apiName, path, myInit));
  return res;
};
const editarTrabajador = async (userToken, registro) => {
  const path = '/trabajador';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

/*** aprobar trabajadores */
const cambioEstadoTrabajador = async (userToken, registro) => {
  const path = '/cambiarEstadoTrabajador';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

/**** Historial trabajador */

const historialTrabajador = async (userToken, correo) => {
  const path = '/trabajadorHistorial';
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    correo,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.get(apiName, path, myInit));
  return res;
};

/*** Editar informacion Trbajadores */
const editarInformacionTrabajador = async (userToken, registro) => {
  const path = '/trabajador';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};
/*** pagos masivos*/
const enviarPagosMasivos = async (userToken, registro, motivo) => {
  const path = '/pagosMasivos';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
    motivo,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

/*** caraga masiva Trabajadores*/
const cargaMasivaTrabajadores = async (userToken, registro, motivo) => {
  const path = '/cargaMasivaTrabajadores';
  const myInit = createParams();
  myInit.body = {
    userToken: await getToken(),
    registro,
    motivo,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

/*** impersonar */

const impersonar = async (app, empresaId, correo, clientId) => {
  const path = '/impersonar';
  const myInit = createParams();
  myInit.body = {
    app,
    empresaId,
    correo,
    clientId,
  };
  //////console.log('Esta es mi solicitud', myInit);
  const res = customFetch(() => API.post(apiName, path, myInit));
  return res;
};

const contratosTrabajador = async (tipo, rut, desde, hasta) => {
  const path = '/contratosTrabajador';
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    tipo,
    rut,
    desde,
    hasta,
  };
  const res = customFetch(() => API.get(apiName, path, myInit));
  return res;
};

const ofertaService = {
  consultarSolicitudes,
  validarOferta,
  consultarHabilidades,
  crearHabilidades,
  editarHabilidades,
  cambioEstadoHabilidad,
  consultarTrabajador,
  crearTrabajador,
  editarTrabajador,
  cambioEstadoTrabajador,
  historialTrabajador,
  editarInformacionTrabajador,
  enviarPagosMasivos,
  cargaMasivaTrabajadores,
  impersonar,
  contratosTrabajador,
};

export default ofertaService;
